import { DEFAULTS } from "./defaults";
import { HASHTAG_TYPE } from "./types";
import { nodeViewDecorator } from "./viewer/hashtagDecorator";
const pluginHashtag = (config) => {
  const pluginConfig = { ...DEFAULTS.config, ...config };
  return {
    config: pluginConfig,
    type: HASHTAG_TYPE,
    nodeViewDecorators: [nodeViewDecorator]
  };
};
export {
  pluginHashtag
};
//# sourceMappingURL=viewer.js.map
